export default "__VITE_ASSET__B2T6hahO__"